// Fuente ÚNICA del catálogo de roles para la visibilidad de estados (progreso e
// incidencias). Antes estaba duplicado en `status-form.vue` (roles + rolesText) y en
// `status.vue` (rolesText inline), con riesgo de desincronizarse y mostrar `undefined`.
//
// `value`    → rol del backend.
// `labelKey` → clave i18n; se traduce en el componente con `$t(labelKey)` (este módulo
//              no tiene acceso a `$t`).
export const STATUS_VISIBILITY_ROLES = [
  { value: 'project_admin', labelKey: 'project_managers' },
  { value: 'viewer', labelKey: 'viewers_users' },
  { value: 'participant', labelKey: 'project_users' },
  { value: 'collaborator', labelKey: 'collaborator_users' },
  { value: 'certifier', labelKey: 'certifiers_users' },
  { value: 'activity_viewer', labelKey: 'viewers_users_activities_only' },
  { value: 'issue_user', labelKey: 'issues_users' },
  { value: 'validation_user', labelKey: 'validation_users' },
  { value: 'issue_admin', labelKey: 'issue_managers' },
  { value: 'issue_resolutor', labelKey: 'issue_resolutor' },
  { value: 'progress_user', labelKey: 'progress_users' },
  { value: 'document_manager', labelKey: 'document_manager' },
  { value: 'task_resolutor', labelKey: 'task_resolutor_title' },
];

// Helper: construye el mapa { value: label_traducido } usando la función `$t` del
// componente que lo invoca. Mantiene una sola definición de los roles.
export function buildRolesTextMap($t) {
  return STATUS_VISIBILITY_ROLES.reduce((acc, role) => {
    acc[role.value] = $t(role.labelKey);
    return acc;
  }, {});
}
